import * as types from '../types/authTypes';

const LS_TOKEN = 'auth_token';
const LS_USER = 'user';

function readStoredToken() {
  try {
    const raw = localStorage.getItem(LS_TOKEN);
    if (!raw) return null;
    try {
      const p = JSON.parse(raw);
      return typeof p === 'string' ? p : String(p);
    } catch {
      return String(raw);
    }
  } catch {
    return null;
  }
}

function readStoredUser() {
  try {
    const raw = localStorage.getItem(LS_USER);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

function persistAuth(token, user) {
  try {
    if (token) localStorage.setItem(LS_TOKEN, JSON.stringify(token));
    else localStorage.removeItem(LS_TOKEN);
    if (user) localStorage.setItem(LS_USER, JSON.stringify(user));
    else localStorage.removeItem(LS_USER);
  } catch {
    /* ignore */
  }
}

const initialState = {
  token: readStoredToken(),
  user: readStoredUser(),
  status: 'idle',
  error: null,
  meLoading: false,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.LOGIN_REQUEST:
      return { ...state, status: 'loading', error: null };
    case types.LOGIN_SUCCESS: {
      const { token, user } = action.payload || {};
      return { ...state, status: 'succeeded', token, user, error: null };
    }
    case types.LOGIN_FAILURE:
      return { ...state, status: 'failed', error: action.payload ?? 'Login failed' };

    case types.REGISTER_REQUEST:
      return { ...state, status: 'loading', error: null };
    case types.REGISTER_SUCCESS: {
      const { token, user } = action.payload || {};
      return { ...state, status: 'succeeded', token, user, error: null };
    }
    case types.REGISTER_FAILURE:
      return { ...state, status: 'failed', error: action.payload ?? 'Registration failed' };

    case types.FETCH_AUTH_ME_REQUEST:
      return { ...state, meLoading: true };
    case types.FETCH_AUTH_ME_SUCCESS:
      return {
        ...state,
        meLoading: false,
        user: action.payload ?? state.user,
      };
    case types.FETCH_AUTH_ME_FAILURE:
      return {
        ...state,
        meLoading: false,
        token: null,
        user: null,
      };

    case types.LOGOUT:
      return {
        ...state,
        token: null,
        user: null,
        status: 'idle',
        error: null,
        meLoading: false,
      };

    case types.CLEAR_AUTH_ERROR:
      return { ...state, error: null };

    default:
      return state;
  }
};

export default authReducer;
export { persistAuth };
